/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbMetierConseillersLiesGridDto } from './FcbMetierConseillersLiesGridDto';
import {
    FcbMetierConseillersLiesGridDtoFromJSON,
    FcbMetierConseillersLiesGridDtoFromJSONTyped,
    FcbMetierConseillersLiesGridDtoToJSON,
} from './FcbMetierConseillersLiesGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbMetierConseillersLiesGridDtoPaginatedResults
 */
export interface FcbMetierConseillersLiesGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbMetierConseillersLiesGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbMetierConseillersLiesGridDto>}
     * @memberof FcbMetierConseillersLiesGridDtoPaginatedResults
     */
    results?: Array<FcbMetierConseillersLiesGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbMetierConseillersLiesGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbMetierConseillersLiesGridDtoPaginatedResults interface.
 */
export function instanceOfFcbMetierConseillersLiesGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierConseillersLiesGridDtoPaginatedResultsFromJSON(json: any): FcbMetierConseillersLiesGridDtoPaginatedResults {
    return FcbMetierConseillersLiesGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbMetierConseillersLiesGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierConseillersLiesGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbMetierConseillersLiesGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbMetierConseillersLiesGridDtoPaginatedResultsToJSON(value?: FcbMetierConseillersLiesGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbMetierConseillersLiesGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

